<template>
  <div class="user_wrap">
    <div class="mine">
      <section class="profile-hero">
        <div class="profile-row">
          <img
            class="avatar"
            :src="avatarSrc"
            alt=""
            @error="avatarError = true"
            @click.stop="avatarPickerVisible = true"
          >
          <div class="profile-info">
            <div class="name-row">
              <span class="nickname">{{ displayName }}</span>
              <span class="vip-badge">{{ data.vip_name || 'VIP' }}</span>
            </div>
            <div class="profile-line">
              {{ $t('user.creditScore') }}：{{ data.score || 100 }}
            </div>
            <div
              class="profile-line invite-code"
              role="button"
              tabindex="0"
              @click="copyInviteCode"
              @keyup.enter="copyInviteCode"
            >
              <span>{{ $t('user.inviteCode') }}：{{ data.yaocode || '--' }}</span>
              <van-icon name="notes-o" />
            </div>
            <div class="profile-line">
              {{ $t('user.account') }}：<strong>{{ utils_moneyMark() }} {{ formatMoney(data.money) }} </strong>
            </div>
          </div>
          <div
            v-if="data.iscouple==1"
            class="r12"
          >
            <img src="../images/shop2/love.png">
          </div>
          <button
            class="logout-btn"
            type="button"
            :aria-label="$t('safe.signOut')"
            @click="logout"
          >
            <img
              :src="logoutIcon"
              alt=""
            >
          </button>
        </div>
      </section>

      <!--     <section class="order-card">
        <h2>{{ $t('user.myOrders') }}</h2>
        <div class="order-list">
          <div
            v-for="item in orderItems"
            :key="item.label"
            class="order-item"
            @click="goRoute(item.route)"
          >
            <van-icon :name="item.icon" />
            <span>{{ $t(item.label) }}</span>
          </div>
        </div>
      </section> -->
      <!-- 
      <div
        class="member-banner"
        :style="{ backgroundImage: 'url(' + memberBanner + ')' }"
      /> -->

      <section class="menu-card">
        <div
          v-for="item in menuItems"
          :key="item.label"
          class="menu-item"
          @click.stop="handleMenu(item)"
        >
          <div
            class="menu-icon-wrap"
            :class="{ hot: item.hot, unread: isUnreadMessageItem(item) }"
          >
            <van-icon :name="item.icon" />
          </div>
          <span>{{ $t(item.label) }}</span>
        </div>
      </section>

      <section class="recommend-section">
        <h2>{{ $t('user.hotelRecommend') }}</h2>
        <div
          v-if="memberRecommends.length"
          class="hotel-grid"
        >
          <article
            v-for="item in memberRecommends"
            :key="item.id"
            class="hotel-card"
            role="button"
            tabindex="0"
            @click="goHotelDetail(item)"
            @keyup.enter="goHotelDetail(item)"
          >
            <img
              :src="hotelImage(item)"
              alt=""
              @error="onHotelImageError"
            >
            <div class="hotel-title">
              {{ item.title || '--' }}
            </div>
            <div class="hotel-meta">
              <span class="price">${{ formatPrice(item.price) }}</span>
              <span class="sold">{{ $t('user.sold') }}{{ formatSold(item.sold) }}</span>
            </div>
          </article>
        </div>
        <div
          v-else
          class="empty-recommend"
        >
          {{ $t('user.emptyRecommend') }}
        </div>
      </section>

      <van-popup
        v-model="show"
        round
        closeable
        :style="{
          'line-height': '30px',
          'width': '70%',
          'padding': '15px',
          'font-weight': 'bold'
        }"
        @close="handleNoticePopupClose"
      >
        {{ msg }}
      </van-popup>
      <avatar-picker
        v-model="avatarPickerVisible"
        :current-avatar="data.user_icon || ''"
        @updated="onAvatarUpdated"
      />
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import AvatarPicker from '../../components/AvatarPicker.vue';
	import {
		Dialog,
		Icon,
		Popup,
	} from "vant";

Vue.use(Icon).use(Popup);

	export default {
		name: "User",
		components: {
			AvatarPicker,
		},
		data() {
			return {
				lang: this.$i18n.locale || "en_us",
				data: {},
				show_kefu: false,
				msg_show: true,
				acc: null,
				msg: null,
				show: false,
				popupMessageId: null,
				unreadCount: 0,
				noticeTimer: null,
				app: null,
				avatarError: false,
				avatarPickerVisible: false,
				defaultAvatar: require('../images/home/headDefault.png'),
				hotelFallback: require('../images/shop2/pro.png'),
				memberBanner: require('../images/user/member_banner.png'),
				logoutIcon: require('../images/user/out.png'),
				orderItems: [
					{ label: 'user.waitDeliver', icon: 'logistics', route: '/myorders' },
					{ label: 'user.living', icon: 'coupon-o', route: '/myorders' },
					{ label: 'user.review', icon: 'comment-o', route: '/myorders' },
					{ label: 'user.completed', icon: 'diamond-o', route: '/myorders' },
				],
				menuItems: [
					{ label: 'user.storeManage', icon: 'shop-o', route: '/shop', hot: true },
					{ label: 'user.fundManage', icon: 'paid', route: '/moneybag' },
					{ label: 'user.customerService', icon: 'service-o', route: '/kefu' },
					{ label: 'user.complaint', icon: 'records', route: '/feedback' },
					{ label: 'user.setting', icon: 'setting-o', route: '/safe' },
					{ label: 'user.aboutUs', icon: 'friends-o', route: '/about' },
					{ label: 'user.favorite', icon: 'bag-o', route: '/collect' },
					{ label: 'user.message', icon: 'bell', route: '/notice' },
					{ label: 'user.level', icon: 'bookmark-o', route: '/vip' },
				],
			};
		},
		computed: {
			displayName() {
				return this.data.name || this.data.mobile || '--';
			},
			avatarSrc() {
				if (this.avatarError) {
					return this.defaultAvatar;
				}
				return this.buildImageUrl(this.data.user_icon, this.defaultAvatar);
			},
			memberRecommends() {
				return Array.isArray(this.data.member_recommend_pros) ? this.data.member_recommend_pros : [];
			},
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
			document.body.addEventListener("scroll", this.handleBodyScroll, false);
			document.addEventListener("click", this.handleDocumentClick, false);
		},
		beforeDestroy() {
			document.body.removeEventListener("scroll", this.handleBodyScroll, false);
			document.removeEventListener("click", this.handleDocumentClick, false);
			if (this.noticeTimer) {
				clearInterval(this.noticeTimer);
				this.noticeTimer = null;
			}
		},
		methods: {
    copyInviteCode() {
      var code = this.data && this.data.yaocode ? String(this.data.yaocode) : "";
      if (!code) {
        return;
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(this.showCopySuccess).catch(function() {
          this.copyWithTextarea(code);
        }.bind(this));
        return;
      }
      this.copyWithTextarea(code);
    },
    copyWithTextarea(code) {
      var input = document.createElement("textarea");
      input.value = code;
      input.setAttribute("readonly", "readonly");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      input.style.top = "0";
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length);
      var copied = document.execCommand("copy");
      document.body.removeChild(input);
      if (copied) {
        this.showCopySuccess();
      }
    },
    showCopySuccess() {
      this.$toast({
        background: "#07c160",
        message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if (data && data.length > 0) {
						this.msg = data[0]["content_"+this.lang];
						this.popupMessageId = Number(data[0].id) || null;
						// console.log(this.lang);
						this.show = true;
					}
				});
			},
			handleNoticePopupClose() {
				// var messageId = this.popupMessageId;
				// this.popupMessageId = null;
				// if (!messageId) {
				// 	return;
				// }
				// Fetch('/user/notice_view', {
				// 	id: messageId
				// }).then(() => {
				// 	this.refreshNoticeStatus();
				// }).catch(() => {});
			},
			start() {
				Fetch('/index/webconfig').then((r) => {
					this.app = r.data;
				});
				Fetch('/user/info').then((r) => {
					this.data = r.data;
					this.acc = r.data;
					this.avatarError = false;
				});
				setTimeout(() => {
					this.sync();
				}, 2000);
				this.refreshNoticeStatus();
				this.noticeTimer = setInterval(this.refreshNoticeStatus, 30000);
			},
			refreshNoticeStatus() {
				Fetch('/user/notice_status').then((r) => {
					this.unreadCount = Number(r.data.unread_count) || 0;
				}).catch(() => {});
			},
			isUnreadMessageItem(item) {
				return item.route === '/notice' && this.unreadCount > 0;
			},
			handleBodyScroll() {
				if (this.show_kefu) {
					this.show_kefu = false;
				}
			},
			handleDocumentClick(ev) {
				if (!ev.target || ev.target.className !== "kefu_img") {
					this.show_kefu = false;
				}
			},
			handleMenu(item) {
				if (item.action === 'service') {
					this.kefu_to();
					return;
				}
				this.goRoute(item.route);
			},
			goRoute(route) {
				if (route) {
					this.$router.push(route);
				}
			},
			goHotelDetail(item) {
				var id = Number(item && item.id ? item.id : 0);
				if (!id) {
					return;
				}
				this.$router.push({
					path: '/hotelit',
					query: {
						id: id,
					},
				});
			},
			kefu_to() {
				if (this.show_kefu && this.app && this.app.kefu_link) {
					var uid = this.acc && this.acc.uid ? this.acc.uid : '';
					var name = this.acc && this.acc.mobile ? this.acc.mobile : '';
					window.location.href = this.app.kefu_link + '&uid=' + uid + '&name=' + name;
					return;
				}
				this.show_kefu = !this.show_kefu;
			},
			buildImageUrl(path, fallback) {
				if (!path) {
					return fallback;
				}
				if (/^(https?:)?\/\//.test(path) || path.indexOf('data:') === 0) {
					return path;
				}
				if (this.app && this.app.domain) {
					return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
				}
				return path;
			},
			onAvatarUpdated(icon) {
				this.$set(this.data, 'user_icon', icon);
				this.avatarError = false;
			},
			hotelImage(item) {
				return this.buildImageUrl(item && item.img, this.hotelFallback);
			},
			onHotelImageError(event) {
				if (event && event.target && event.target.src !== this.hotelFallback) {
					event.target.src = this.hotelFallback;
				}
			},
			formatMoney(value) {
				var number = Number(value);
				if (!isFinite(number)) {
					number = 0;
				}
				return number.toLocaleString('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
			},
			formatPrice(value) {
				return this.formatMoney(value);
			},
			formatSold(value) {
				var number = Number(value);
				if (!isFinite(number) || number < 0) {
					number = 0;
				}
				if (number >= 1000) {
					var shortNumber = number / 1000;
					var fixed = shortNumber >= 10 ? shortNumber.toFixed(0) : shortNumber.toFixed(1);
					return fixed.replace(/\.0$/, '') + 'k+';
				}
				return String(Math.floor(number));
			},
			logout() {
				Dialog.confirm({
					title: this.$t('safe.signOut'),
					message: this.$t('user.logoutConfirm'),
					confirmButtonText: this.$t('utils.confirm'),
					cancelButtonText: this.$t('utils.cancel'),
				}).then(() => {
					localStorage.removeItem('token');
					this.$router.replace("/");
				}).catch(() => {});
			}
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		max-width: 100%;
		background: #eeeeee;
	}

	.mine {
		min-height: calc(100vh - 1.78667rem);
		padding-bottom: 82px;
		background: #eeeeee;
		color: #222637;
	}

	.profile-hero {
		padding: 26px 17px 70px;
		background: linear-gradient(135deg, #ffd927 0%, #ffb01f 48%, #ff8418 100%);
	}

	.profile-row {
		display: flex;
		align-items: center;
		position: relative;
	}

	.avatar {
		width: 82px;
		height: 82px;
		flex: 0 0 82px;
		border-radius: 50%;
		border: 4px solid rgba(255, 255, 255, .9);
		background: #fff;
		object-fit: contain;
		box-shadow: 0 4px 14px rgba(255, 137, 23, .3);
	}

	.profile-info {
		min-width: 0;
		padding: 0 48px 0 18px;
	}

	.name-row {
		display: flex;
		align-items: center;
		min-width: 0;
		margin-bottom: 8px;
	}

	.nickname {
		max-width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
		line-height: 20px;
		font-weight: 700;
		color: #111827;
	}

	.vip-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 45px;
		height: 22px;
		margin-left: 9px;
		padding: 0 8px;
		border-radius: 5px;
		background: #17101f;
		color: #fff;
		font-size: 12px;
		line-height: 22px;
		font-weight: 700;
	}

	.profile-line {
		font-size: 14px;
		line-height: 23px;
		color: #222637;
		word-break: break-word;
	}

	.profile-line strong {
		font-size: 14px;
		color: #24324a;
	}

.invite-code {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.invite-code .van-icon {
  flex: 0 0 auto;
  padding: 2px;
  font-size: 14px;
  color: #1d2430;
}

	.logout-btn {
		position: absolute;
		right: 0;
		top: 20px;
		width: 44px;
		height: 38px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 0;
		background: transparent;
		color: #111827;
		padding: 0;
	}

	.logout-btn img {
		display: block;
		width: 38px;
		height: 38px;
		object-fit: contain;
	}

	.order-card,
	.menu-card {
		margin: -40px 17px 0;
		background: #fff;
		border-radius: 11px;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(31, 41, 55, .05);
	}

	.order-card h2,
	.recommend-section h2 {
		margin: 0;
		font-size: 14px;
		line-height: 20px;
		font-weight: 500;
		color: #283043;
	}

	.order-card h2 {
		padding: 17px 15px 10px;
	}

	.order-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		padding: 5px 0 23px;
	}

	.order-item {
		min-width: 0;
		text-align: center;
		color: #2c2232;
	}

	.order-item .van-icon {
		display: block;
		margin-bottom: 14px;
		font-size: 28px;
		color: #211528;
	}

	.order-item span {
		display: block;
		font-size: 12px;
		line-height: 16px;
		color: #5c5f68;
	}

	.member-banner {
		height: 74px;
		margin: 0 17px;
		background-repeat: no-repeat;
		background-position: center center;
		background-size: cover;
	}

	.menu-card {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px 12px;
		margin-top: -40px;
		padding: 14px;
	}

	.menu-item {
		height: 84px;
		border-radius: 8px;
		background: #f7f8fc;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #172033;
	}

	.menu-icon-wrap {
		position: relative;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;
		color: #83a4d2;
	}

	.menu-icon-wrap.hot::after {
		content: '';
		position: absolute;
		top: -2px;
		right: -2px;
		width: 9px;
		height: 9px;
		border-radius: 50%;
		background: #ff003b;
	}

	.menu-icon-wrap.unread,
	.menu-icon-wrap.unread .van-icon {
		color: #ff1724;
	}

	.menu-icon-wrap .van-icon {
		font-size: 29px;
	}

	.menu-item span {
		font-size: 12px;
		line-height: 17px;
	}

	.recommend-section {
		padding: 28px 17px 0;
	}

	.recommend-section h2 {
		text-align: center;
		margin-bottom: 14px;
		font-size: 14px;
	}

	.hotel-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		padding: 11px;
		border-radius: 7px;
		background: #fff;
	}

	.hotel-card {
		min-width: 0;
		overflow: hidden;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.hotel-card img {
		width: 100%;
		height: 102px;
		display: block;
		border-radius: 6px;
		object-fit: cover;
		background: #e5e7eb;
	}

	.hotel-title {
		margin-top: 7px;
		font-size: 12px;
		line-height: 16px;
		color: #111827;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.hotel-meta {
		display: flex;
		align-items: baseline;
		min-width: 0;
		margin-top: 3px;
		line-height: 16px;
	}

	.price {
		font-size: 12px;
		font-weight: 700;
		color: #ff0018;
		white-space: nowrap;
	}

	.sold {
		min-width: 0;
		margin-left: 5px;
		font-size: 10px;
		color: #8a8d96;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.empty-recommend {
		padding: 24px 12px;
		border-radius: 7px;
		background: #fff;
		text-align: center;
		font-size: 12px;
		color: #8a8d96;
	}

	.kefu {
		position: fixed;
		right: 13px;
		bottom: 95px;
		z-index: 12;
		width: 68px;
		height: 68px;
		border-radius: 50%;
		overflow: hidden;
		border: 4px solid #fff;
		background: linear-gradient(180deg, #1884ff 0%, #1884ff 68%, #f70720 68%, #f70720 100%);
		box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
		transition: transform .25s ease;
		box-sizing: border-box;
	}

	.kefu_hide {
		transform: translateX(38px);
	}

	.kefu_img {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
	}

	.kefu_img .van-icon {
		font-size: 38px;
		font-weight: 700;
	}
	
	.r12{
	    margin-top: 50px;
	    margin-right: 10px;
		img {
		    width: 60px;
		}
	}
	
</style>
